"use client";

import { useId, useRef } from "react";
import { motion, useInView, Variants } from "framer-motion";

const CHART_BASELINE = 323.7;

type Bar = {
    x: number;
    y: number;
    w: number;
    h: number;
    rx: number;
    fill: string;
    opacity?: number;
};

const COLUMNS: Bar[][] = [
    [
        { x: 24.7, y: 244.4, w: 27.3, h: 79.3, rx: 13.65, fill: "#A4A2D4" },
        { x: 24.7, y: 269.1, w: 27.3, h: 54.6, rx: 13.65, fill: "#4A46A9" },
        { x: 24.7, y: 275.6, w: 27.3, h: 48.1, rx: 13.65, fill: "#000000", opacity: 0.25 },
    ],
    [
        { x: 53.7544, y: 230.1, w: 27.3, h: 93.6, rx: 13.65, fill: "#A4A2D4" },
        { x: 53.7544, y: 253.5, w: 27.3, h: 70.2, rx: 13.65, fill: "#4A46A9" },
        { x: 53.7544, y: 287.3, w: 27.3, h: 36.4, rx: 13.65, fill: "#000000", opacity: 0.25 },
    ],
    [
        { x: 82.8093, y: 258.7, w: 27.3, h: 65, rx: 13.65, fill: "#A4A2D4" },
        { x: 82.8093, y: 267.8, w: 27.3, h: 55.9, rx: 13.65, fill: "#4A46A9" },
        { x: 82.8093, y: 287.3, w: 27.3, h: 36.4, rx: 13.65, fill: "#000000", opacity: 0.25 },
    ],
    [
        { x: 111.864, y: 253.5, w: 27.3, h: 70.2, rx: 13.65, fill: "#A4A2D4" },
        { x: 111.864, y: 261.3, w: 27.3, h: 62.4, rx: 13.65, fill: "#4A46A9" },
        { x: 111.864, y: 283.4, w: 27.3, h: 40.3, rx: 13.65, fill: "#000000", opacity: 0.25 },
    ],
    [
        { x: 140.919, y: 244.4, w: 27.3, h: 79.3, rx: 13.65, fill: "#A4A2D4" },
        { x: 140.919, y: 269.1, w: 27.3, h: 54.6, rx: 13.65, fill: "#4A46A9" },
        { x: 140.919, y: 275.6, w: 27.3, h: 48.1, rx: 13.65, fill: "#000000", opacity: 0.25 },
    ],
    [
        { x: 169.973, y: 258.7, w: 27.3, h: 65, rx: 13.65, fill: "#A4A2D4" },
        { x: 169.973, y: 265.2, w: 27.3, h: 58.5, rx: 13.65, fill: "#4A46A9" },
        { x: 169.973, y: 275.6, w: 27.3, h: 48.1, rx: 13.65, fill: "#000000", opacity: 0.25 },
    ],
    [
        { x: 199.028, y: 241.8, w: 27.3, h: 81.9, rx: 13.65, fill: "#A4A2D4" },
        { x: 199.028, y: 234, w: 27.3, h: 89.7, rx: 13.65, fill: "#4A46A9" },
        { x: 199.028, y: 260, w: 27.3, h: 63.7, rx: 13.65, fill: "#000000", opacity: 0.25 },
    ],
    [
        { x: 228.082, y: 228.8, w: 27.3, h: 94.9, rx: 13.65, fill: "#A4A2D4" },
        { x: 228.082, y: 241.8, w: 27.3, h: 81.9, rx: 13.65, fill: "#4A46A9" },
        { x: 228.082, y: 260, w: 27.3, h: 63.7, rx: 13.65, fill: "#000000", opacity: 0.25 },
    ],
    [
        { x: 257.099, y: 175.503, w: 27.3, h: 148.2, rx: 13.65, fill: "#A4A2D4" },
        { x: 257.099, y: 236.604, w: 27.3, h: 87.1, rx: 13.65, fill: "#4A46A9" },
        { x: 257.099, y: 249.604, w: 27.3, h: 74.1, rx: 13.65, fill: "#000000", opacity: 0.25 },
    ],
    [
        { x: 286.999, y: 198.904, w: 27.3, h: 124.8, rx: 13.65, fill: "#A4A2D4" },
        { x: 286.999, y: 217.104, w: 27.3, h: 106.6, rx: 13.65, fill: "#4A46A9" },
        { x: 286.999, y: 241.803, w: 27.3, h: 81.9, rx: 13.65, fill: "#000000", opacity: 0.25 },
    ],
    [
        { x: 316.899, y: 165.104, w: 27.3, h: 158.6, rx: 13.65, fill: "#A4A2D4" },
        { x: 316.899, y: 217.104, w: 27.3, h: 106.6, rx: 13.65, fill: "#4A46A9" },
        { x: 316.899, y: 231.404, w: 27.3, h: 92.3, rx: 13.65, fill: "#000000", opacity: 0.25 },
    ],
    [
        { x: 346.799, y: 170.303, w: 27.3, h: 153.4, rx: 13.65, fill: "#A4A2D4" },
        { x: 346.799, y: 206.703, w: 27.3, h: 117, rx: 13.65, fill: "#4A46A9" },
        { x: 346.799, y: 221.003, w: 27.3, h: 102.7, rx: 13.65, fill: "#000000", opacity: 0.25 },
    ],
    [
        { x: 376.699, y: 130.003, w: 26, h: 193.7, rx: 13, fill: "#A4A2D4" },
        { x: 376.699, y: 157.303, w: 26, h: 166.4, rx: 13, fill: "#4A46A9" },
        { x: 376.699, y: 197.604, w: 26, h: 126.1, rx: 13, fill: "#000000", opacity: 0.25 },
    ],
    [
        { x: 405.299, y: 109.203, w: 27.3, h: 214.5, rx: 13.65, fill: "#A4A2D4" },
        { x: 405.299, y: 131.303, w: 27.3, h: 192.4, rx: 13.65, fill: "#4A46A9" },
        { x: 405.299, y: 226.203, w: 27.3, h: 97.5, rx: 13.65, fill: "#000000", opacity: 0.25 },
    ],
    [
        { x: 435.199, y: 111.803, w: 27.3, h: 211.9, rx: 13.65, fill: "#A4A2D4" },
        { x: 435.199, y: 128.703, w: 27.3, h: 195, rx: 13.65, fill: "#4A46A9" },
        { x: 435.199, y: 183.303, w: 27.3, h: 140.4, rx: 13.65, fill: "#000000", opacity: 0.25 },
    ],
    [
        { x: 465.099, y: 87.1035, w: 27.3, h: 236.6, rx: 13.65, fill: "#A4A2D4" },
        { x: 465.099, y: 106.604, w: 27.3, h: 217.1, rx: 13.65, fill: "#4A46A9" },
        { x: 465.099, y: 136.503, w: 27.3, h: 187.2, rx: 13.65, fill: "#000000", opacity: 0.25 },
    ],
    [
        { x: 494.999, y: 84.5034, w: 27.3, h: 239.2, rx: 13.65, fill: "#A4A2D4" },
        { x: 494.999, y: 98.8035, w: 27.3, h: 224.9, rx: 13.65, fill: "#4A46A9" },
        { x: 494.999, y: 139.104, w: 27.3, h: 184.6, rx: 13.65, fill: "#000000", opacity: 0.25 },
    ],
];

const COLUMN_STAGGER = 0.035;
const BAR_DURATION = 0.65;
const LINE_DELAY = COLUMNS.length * COLUMN_STAGGER + 0.1;

const TREND_COLOR = "#4A46A9";
const TREND_CURVE = "M38 211 Q210 198 382 81";
const TREND_ARROW = "M376.1 80.8 L382.5 80.4 L381.84 86.8";

const growBar: Variants = {
    hidden: { scaleY: 0 },
    visible: (delay: number) => ({
        scaleY: 1,
        transition: { duration: BAR_DURATION, ease: [0.16, 1, 0.3, 1], delay },
    }),
};

const lineReveal: Variants = {
    hidden: { width: 0 },
    visible: {
        width: 549,
        transition: { duration: 1, ease: [0.16, 1, 0.3, 1], delay: LINE_DELAY },
    },
};

type Props = {
    ariaLabel?: string;
};

const ImprovementChart = ({
    ariaLabel = "Bar chart showing improvement in Desire Score, satisfying events per month, and Arousal Score over time",
}: Props) => {
    const ref = useRef<HTMLDivElement>(null);
    const isInView = useInView(ref, { once: true, amount: 0.3 });
    const animate = isInView ? "visible" : "hidden";

    const lineRevealId = `improvementChartLineReveal-${useId()}`;

    return (
        <div ref={ref} className="w-full">
            <svg
                viewBox="0 0 549 350"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ width: "100%", height: "auto" }}
                role="img"
                aria-label={ariaLabel}
            >
                <rect width="548.22" height="349.7" rx="24.4332" fill="#E9EDF7" />

                <defs>
                    <clipPath id={lineRevealId}>
                        <motion.rect
                            x="0"
                            y="0"
                            height="350"
                            variants={lineReveal}
                            initial="hidden"
                            animate={animate}
                        />
                    </clipPath>
                </defs>

                {COLUMNS.map((bars, columnIndex) => (
                    <motion.g
                        key={columnIndex}
                        variants={growBar}
                        initial="hidden"
                        animate={animate}
                        custom={columnIndex * COLUMN_STAGGER}
                        style={{
                            transformBox: "view-box",
                            transformOrigin: `0px ${CHART_BASELINE}px`,
                        }}
                    >
                        {bars.map((bar, barIndex) => (
                            <rect
                                key={barIndex}
                                x={bar.x}
                                y={bar.y}
                                width={bar.w}
                                height={bar.h}
                                rx={bar.rx}
                                fill={bar.fill}
                                fillOpacity={bar.opacity}
                            />
                        ))}
                    </motion.g>
                ))}

                <g clipPath={`url(#${lineRevealId})`}>
                    <path
                        d={TREND_CURVE}
                        fill="none"
                        stroke={TREND_COLOR}
                        strokeWidth={1.6}
                        strokeDasharray="4 4"
                        strokeLinecap="round"
                    />
                    <path
                        d={TREND_ARROW}
                        fill="none"
                        stroke={TREND_COLOR}
                        strokeWidth={1.6}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            </svg>
        </div>
    );
};

export default ImprovementChart;
